import type { TOC } from '@ember/component/template-only';

interface HotelAndMarketRevenueInsightTablesCellsTdTitleAttributeSignature {
  Args: {
    cellData: string;
    column: {
      hasLineClampTwo: boolean;
    };
  };
}

const HotelAndMarketRevenueInsightTablesCellsTdTitleAttribute = <template>
  <div
    class={{if @column.hasLineClampTwo "line-clamp-2" "truncate"}}
    title={{@cellData}}
  >
    {{@cellData}}
  </div>
</template> satisfies TOC<HotelAndMarketRevenueInsightTablesCellsTdTitleAttributeSignature>;

export default HotelAndMarketRevenueInsightTablesCellsTdTitleAttribute;
